import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { intl } from '../../../../modules/Intl/IntlGlobalWrapper';
import { saveConfig, updateBreakdownField, updateEnabledColors, updateFieldColors } from '../../FilterActions';
import { CustomSelect } from '../common';
import textUtils from '../../../../util/text';
import { hasLabels } from '../../../../util/customFieldsUtils';

class BreakdownBy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  componentDidMount() {
    this.updateState();
    this.props.updateFieldColors(this.props.breakdownBy, this.props.chart);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customFields != this.props.customFields) {
      this.updateState();
    }
  }

  updateState() {
    const items = _.map(this.props.customFields, cf => {
      return {
        label: cf.name,
        value: cf.extId
      };
    });

    const { app, dashboard } = this.props;
    const fileApp = (app === 'file' && !dashboard.isCsv) && (dashboard.isAzure ? 'azure' : 'jira');

    if (!dashboard.isCsv) {
      if (hasLabels(app, dashboard.selectedFields)) {
        items.unshift({
          label: textUtils.format(intl.formatMessage({ id: `${fileApp || app}.label` }), '', true, false, 'capitalize'),
          value: 'labels'
        });
      }
      items.unshift({
        label: textUtils.format(intl.formatMessage({ id: `${fileApp || app}.list` }), '', true, false, 'capitalize'),
        value: 'lists'
      });
    }

    this.setState({
      items
    });
  }

  handleChange = ev => {
    this.props.updateBreakdownField(ev, this.props.chart);
    this.props.updateEnabledColors(ev, this.props.chart);
    this.props.updateFieldColors(ev, this.props.chart);
    this.props.saveConfig();
  };

  render() {
    const { items } = this.state;

    return (
      <CustomSelect
        name={'breakdownBy'}
        title={'Breakdown by'}
        items={items}
        value={this.props.breakdownBy}
        onSelect={this.handleChange}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateBreakdownField: (field, chart) => dispatch(updateBreakdownField(field, chart)),
    updateFieldColors: (field, chart) => dispatch(updateFieldColors(field, chart)),
    updateEnabledColors: (field, chart) => dispatch(updateEnabledColors(field, chart))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    customFields: state.app.data && state.app.data.customFields ? state.app.data.customFields : [],
    chart: state.filters.chart,
    breakdownBy: state.filters[state.filters.chart].breakdownBy,
    dashboard: state.dashboards.selected
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(BreakdownBy);
export { connected as BreakdownBy };
